import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCol, IonContent, IonGrid, IonLabel, IonPage, IonRow, IonSelect, IonSelectOption } from "@ionic/react";

import { SessionDefaultStateI } from "../../store/session/SessionReducer";
import { LogsDefaultStateI } from "../../store/logs/logsReducer";
import { GetLogs } from "../../store/logs/logsActions";
import ApiRequestor from "../../api_access/ApiRequestor";

import Header from "../header/Header";
import LogsTable from "./LogsTable";
import LogsModal from "./LogsModal";
import Modal from "../Modal/Modal";
import Loading from "../Loading/Loading";

import "./Logs.css";

interface Props extends StateTypes, dispatchTypes { }

const LogsMainView: React.FC<Props> = (props): JSX.Element => {
    const [logsData, setLogsData] = useState<any[]>([]);
    const [logsEventoData, setLogsEventoData] = useState<string[]>([]);
    const [logsUsuarioData, setLogsUsuarioData] = useState<string[]>([]);
    const [logsAccionData, setLogsAccionData] = useState<string[]>([]);
    const [logsClienteData, setLogsClienteData] = useState<string[]>([]);
    const [logsInfo, setLogsInfo] = useState<string[]>([]);
    const [filters, setFilters] = useState<{ [key: string]: string }>({});
    const [selectedEvento, setSelectedEvento] = useState<string | undefined>();
    const [selectedAccion, setSelectedAccion] = useState<string | undefined>();
    const [selectedUsuario, setSelectedUsuario] = useState<string | undefined>();
    const [selectedCliente, setSelectedCliente] = useState<string | undefined>();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState<string>("");
    const [modalError, setModalError] = useState<string | undefined>(undefined);
    const [showAlert, setShowAlert] = useState(false);
    const [showModalSuccessDelete, setShowModalSuccessDelete] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 15;

    const totalPages = Math.ceil(logsData.length / logsPerPage);
    const indexOfLastLog = currentPage * logsPerPage;
    const indexOfFirstLog = indexOfLastLog - logsPerPage;
    const currentLogs = logsData.slice(indexOfFirstLog, indexOfLastLog);

    useEffect(() => {
        if (!props.session.loading && props.session.loginData) {
            props.getLogs();
        }
    }, []);

    useEffect(() => {
        if (!props.logs.loading && props.logs.logs) {
            const data = props.logs.logs.data;
            setLogsData(data);
            setLogsEventoData(Array.from(new Set(data.map((log: any) => log.event_name))));
            setLogsUsuarioData(Array.from(new Set(data.map((log: any) => log.log_user))));
            setLogsAccionData(Array.from(new Set(data.map((log: any) => log.event_type))));
            setLogsClienteData(Array.from(new Set(data.map((log: any) => log.log_service_name))));
            setLogsInfo(Array.from(new Set(data.map((log: any) => log.log_info))));
        }
    }, [props.logs.loading, props.logs.logs]);

    const handleFiltrar = () => {
        setCurrentPage(1);
        const filters: {
            event_name?: string;
            event_type?: string;
            username?: string;
            service_name?: string;
        } = {};

        if (selectedEvento) filters.event_name = selectedEvento;
        if (selectedAccion) filters.event_type = selectedAccion;
        if (selectedUsuario) filters.username = selectedUsuario;
        if (selectedCliente) filters.service_name = selectedCliente;
        if (Object.keys(filters).length > 0) {
            props.getLogs(filters);
        } else {
            props.getLogs();
        }
    };

    const handleLimpiar = () => {
        setFilters({});
        setSelectedEvento(undefined);
        setSelectedAccion(undefined);
        setSelectedUsuario(undefined);
        setSelectedCliente(undefined);
        setCurrentPage(1);
        props.getLogs();
    };

    const renderSelect = (
        label: string,
        data: string[],
        type: string,
        value: string | undefined,
        onChange: (value: string | undefined) => void
    ) => {
        const filteredData = data.filter((item) => item && item.trim() !== "");

        return (
            <>
                <IonLabel className="logs-filtro-label">{label}</IonLabel>
                <IonSelect
                    interface="popover"
                    className="logs-filtro-select"
                    placeholder={`Seleccione ${label.toLowerCase()}`}
                    value={value}
                    onIonChange={(e) => {
                        const selectedValue = e.detail.value;
                        onChange(selectedValue);

                        if (selectedValue && selectedValue.trim() !== "") {
                            setFilters(prev => ({ ...prev, [type]: selectedValue }));
                        } else {
                            setFilters(prev => {
                                const newFilters = { ...prev };
                                delete newFilters[type];
                                return newFilters;
                            });
                        }
                    }}
                >
                    {filteredData.length > 0 ? (
                        filteredData.map((item) => (
                            <IonSelectOption key={item} value={item} className="font-select-logs">
                                {item}
                            </IonSelectOption>
                        ))
                    ) : (
                        <IonSelectOption disabled>No hay datos</IonSelectOption>
                    )}
                </IonSelect>
            </>
        );
    };

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const pages = [];
        for (let i = 1; i <= totalPages; i++) {
            pages.push(
                <IonButton
                    key={i}
                    size="small"
                    className="logs-button"
                    fill={currentPage === i ? "outline" : "solid"}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </IonButton>
            );
        }

        return (
            <IonRow className="logs-pagination-row">
                <IonButton size="small" className="logs-button" disabled={currentPage === 1} onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
                    « ANTERIOR
                </IonButton>
                {pages}
                <IonButton size="small" className="logs-button" disabled={currentPage === totalPages} onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>
                    SIGUIENTE »
                </IonButton>
            </IonRow>
        );
    };

    const deletePeriodo = async (id: string) => {
        let data: any = {
            params: [id]
        };
    
        const response = await ApiRequestor.requestToApi("/swt-admin/logs", "DELETE", data);
    
        if (response && response.status === 200) {
            setShowAlert(false);
            setShowModalSuccessDelete(true);
            setShowDeleteModal(false);
            setSelectedPeriod("");
            setModalError(undefined);
            props.getLogs();
        }
    };
    
    const deletePeriodModal = () => {
        setShowAlert(false);
        setShowModalSuccessDelete(false);
        setSelectedPeriod("");
        setModalError(undefined);
    };

    return (
        <IonPage>
            <Header headerText="Logs" />
            {
            props.logs.loading === false && props.logs.logs ?
            <div className="custom-content-scroll">
                <IonCard class="logs-card">
                    <IonCardHeader>
                        <IonGrid className="logs-filtro-grid">
                            <IonRow>
                                <IonCol sizeXl="3" sizeXs="12">
                                    {renderSelect("Evento", logsEventoData, "event_name", selectedEvento, setSelectedEvento)}
                                </IonCol>
                                <IonCol sizeXl="3" sizeXs="12">
                                    {renderSelect("Tipo de Acción", logsAccionData, "event_type", selectedAccion, setSelectedAccion)}
                                </IonCol>
                                <IonCol sizeXl="3" sizeXs="12">
                                    {renderSelect("Usuario", logsUsuarioData, "username", selectedUsuario, setSelectedUsuario)}
                                </IonCol>
                                <IonCol sizeXl="3" sizeXs="12">
                                    {renderSelect("Cliente Afectado", logsClienteData, "service_name", selectedCliente, setSelectedCliente)}
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol className="logs-filtro-button">
                                    <IonButton onClick={handleFiltrar} fill="outline" className="logs-button">FILTRAR</IonButton>
                                    <IonButton onClick={handleLimpiar} fill="outline" className="logs-button limpiar-button">LIMPIAR</IonButton>
                                    <IonButton fill="outline" className="log-card-button" onClick={() => setShowDeleteModal(true)}
                                    >ELIMINAR LOGS</IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                    </IonCardHeader>

                    <IonCardContent className="logs-table logs-table-card login-table-margin-card">
                        <IonRow className="logs-table-rows">
                            <IonCol sizeXl="2" sizeXs="8" className="logs-table-title">Logs</IonCol>
                            <IonCol sizeXl="3" className="logs-table-title mobile-hidden">Descripción</IonCol>
                            <IonCol sizeXl="2" sizeXs="4" className="logs-table-title mobile-hidden">Información</IonCol>
                            <IonCol sizeXl="2" sizeXs="4" className="logs-table-title">Usuarios</IonCol>
                            <IonCol sizeXl="2" className="logs-table-title mobile-hidden">Clientes</IonCol>
                            <IonCol sizeXl="1" className="logs-table-title mobile-hidden">Fecha</IonCol>
                        </IonRow>

                        {currentLogs.length > 0 ? (
                            currentLogs.map((log: any) => (
                                <LogsTable key={log.log_id} logsData={log} />
                            ))
                        ) : (
                            <IonRow><IonCol>No hay Logs</IonCol></IonRow>
                        )}
                    </IonCardContent>

                    {renderPagination()}
                </IonCard>

                <LogsModal
                    key={showDeleteModal ? 'modal-open' : 'modal-closed'}
                    isOpen={showDeleteModal}
                    onClose={() => {
                        console.log("Cerrando modal...");
                        setShowDeleteModal(false);
                        setSelectedPeriod("");
                        setModalError(undefined);
                    }}
                    onConfirm={() => {
                        if (!selectedPeriod) {
                            setModalError("Debe seleccionar un período para continuar.");
                        } else {
                            setModalError(undefined);
                            setShowAlert(true);
                        }
                    }}
                    selectedPeriod={selectedPeriod}
                    setSelectedPeriod={setSelectedPeriod}
                    errorMessage={modalError}
                />

                <Modal
                    modalPrincipal={{
                        textPrincipal: `¿Deseas eliminar el período ${selectedPeriod}?`,
                        isOpen: showAlert,
                        onDidDismiss: () => setShowAlert(false),
                        onClickCloseModal: () => setShowAlert(false),
                        onClick: () => deletePeriodo(selectedPeriod),
                        nameIcon: "warningOutline",
                        colorIcon: "warning"
                    }}
                    modalConfirmation={{
                        textConfirmation: 'Período de Logs Eliminado con Éxito',
                        onDidDimissConfirmModal: () => deletePeriodModal(),
                        isOpenModalConfirm: showModalSuccessDelete,
                        onClickConfirmModal: () => deletePeriodModal()
                    }}
                />
            </div>
            : 
            <Loading/>
                }
        </IonPage>
    );
};

interface StateTypes {
    session: SessionDefaultStateI;
    logs: LogsDefaultStateI;
}

const mapStateProps = (state: StateTypes) => ({
    session: state.session,
    logs: state.logs
});

interface dispatchTypes {
    getLogs: (params?: {
        event_name?: string;
        event_type?: string;
        username?: string;
        service_name?: string;
    }) => void;
}

const mapDispatchToProps = (dispatch: any) => ({
    getLogs: (params?: {
        event_name?: string;
        event_type?: string;
        username?: string;
        service_name?: string;
    }) => dispatch(GetLogs(params))
});

export default connect(mapStateProps, mapDispatchToProps)(LogsMainView);
